import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import {
  updateLocatorAsync,
  clearMessages,
  selectUpdateLoading,
  selectUpdateError,
  selectUpdateSuccessMsg,
} from '../../redux/locatorManagement/updateLocatorSlice';

export default function useEditLocator(onSuccess) {
  const dispatch = useDispatch();
  const form = useForm({ defaultValues: { locator_type: '', locator_value: '' } });
  const [row, setRow] = useState(null);

  const loading = useSelector(selectUpdateLoading);
  const error = useSelector(selectUpdateError);
  const successMsg = useSelector(selectUpdateSuccessMsg);

  useEffect(() => {
    if (!successMsg) return;
    const timer = setTimeout(() => dispatch(clearMessages()), 3000);
    return () => clearTimeout(timer);
  }, [successMsg, dispatch]);

  const handleOpen = (editRow) => {
    form.reset({ locator_type: editRow.locator_type, locator_value: editRow.locator_value });
    dispatch(clearMessages());
    setRow(editRow);
  };

  const handleClose = () => {
    setRow(null);
    form.reset();
    dispatch(clearMessages());
  };

  const handleSave = form.handleSubmit(async (data) => {
    try {
      await dispatch(updateLocatorAsync({ id: row.id, ...data })).unwrap();
      setRow(null);
      onSuccess?.();
    } catch {
      // error shown via Redux state
    }
  });

  return {
    form,
    row,
    loading,
    error,
    successMsg,
    handleOpen,
    handleClose,
    handleSave,
    clearMessages: () => dispatch(clearMessages()),
  };
}
